import classes from './Telecommunications.module.scss'
import React, {useEffect} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import BlueGradientBlock from "../../../components/blue-gradient-block/BlueGradientBlock.tsx";
import GrayCardWithVerticalDivider
    from "../../../components/gray-card-with-vertical-divider/GrayCardWithVerticalDivider.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import eRoadImg from '../../../media/projects/e-road.webp'
import {Link} from "react-scroll";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const Telecommunications = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const { t } = useTranslation();
    
    const title = t('telecommunications.title')
    const description = t('telecommunications.text', {returnObjects: true})

    const blackBlocks = t('telecommunications.blackBlocks', {returnObjects: true})

    const challengesBlocks = t('telecommunications.challengesBlocks', {returnObjects: true})

    const solutionsBlocks= t('telecommunications.solutionsBlocks', {returnObjects: true})

    const benefitBlocks= t('telecommunications.benefitBlocks', {returnObjects: true})

    const stories = t('telecommunications.stories', {returnObjects: true})



    const useCaseText = t('telecommunications.useCaseSubtitle')

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
        left: t('telecommunications.Faq.left', {returnObjects: true}),
        right: t('telecommunications.Faq.right', {returnObjects: true}),
    };

    return (
        <>
            <Helmet>
                <title>
                    Telecommunications IT Solutions 📡 5G, Billing & Automation
                </title>
                <meta
                    name="description"
                    content="Upgrade your telecom business with 5G, AI-driven customer support & automated billing systems. 🚀 Optimize connectivity & efficiency today! 🌎"
                />
                <link rel="canonical" href="https://go-te.co/industries/telecommunications" />
            </Helmet>
            <main>
                <Heading title={title} description={description} maxWidth={770}/>

                <section className={`section--white ${classes['digital-transformation']}`} id={"nav-dark"}>
                    <div>
                        <h3>{t('telecommunications.blackBlocksTitle')}</h3>
                        <p>{t('telecommunications.blackBlocksText')}</p>
                        <p>{t('telecommunications.blackBlocksText2')}</p>
                    </div>
                    <div className={classes.blocks}>
                        {blackBlocks.map(({text, icon}) => (
                            <BlackCardWithIcon key={icon} iconName={icon} text={text}/>))}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['key-challenges']}`} id={"nav-light"}>
                    <div>
                        <h2>{t('telecommunications.challengesBlocksTitle')}</h2>
                        <p>{t('telecommunications.challengesBlocksText')}</p>
                    </div>

                    <div>
                        {challengesBlocks.map(({icon, text, title}) => <GrayCardBlueIcon iconName={icon} title={title}
                                                                                         text={text} key={title}/>)}
                    </div>
                </section>

                <section className={`section--white ${classes['solutions']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('telecommunications.solutionsBlocksTitle')}</h2>
                        <p>{t('telecommunications.solutionsBlocksText')}</p>
                    </div>

                    <div>
                        {solutionsBlocks.map(({image, title, text}) => <div className={classes.block} key={title}>
                            <img alt={title} src={require(`./media/${image}`)}/>
                            <div className={classes.content}>
                                <h5>{title}</h5>
                                <p>{text}</p>
                            </div>
                        </div>)}
                    </div>
                </section>

                <section className={`section--light-gray ${classes['benefits']}`} id={"nav-dark"}>
                    <div>
                        <h2>{t('telecommunications.benefitBlocksTitle')}</h2>
                    </div>

                    <div>
                        {benefitBlocks.map(({title, text}) => <BlueGradientBlock title={title} text={text}
                                                                                 key={title}/>)}
                    </div>
                </section>

                <section className={"section--dark-gray " + classes['stories']}>
                    <h2>{t('telecommunications.storiesTitle')}</h2>
                    <div className={classes.blocks}>
                        {stories.map(({title, text}) => <GrayCardWithVerticalDivider title={title} text={text}
                                                                                     key={title}/>)}
                    </div>
                </section>

                <section className={`section--dark-gray ${classes['use-case']}`} id={"nav-light"}>
                    <div className={classes.content}>
                        <div className={classes['text-block']}>
                            <h2>{t('telecommunications.useCase')}</h2>
                            <div className={classes.text}>
                                <img src={eRoadImg} alt="Telecommunications use case"/>
                                <p>{useCaseText}</p>
                            </div>
                        </div>
                        <div className={classes.actions}>
                            <span>{t('telecommunications.useCaseText')}</span>
                            <Link className={classes.link} smooth={true} to={'contact'}>
                                {t('telecommunications.useCaseButton')}
                            </Link>
                        </div>
                    </div>
                    <img className={classes.img} src={eRoadImg} alt="Telecommunications system"/>
                </section>

                <section className="section--white" id="nav-dark">
                    <FormCard
                        title={t('telecommunications.formCard.title')}
                        message={t('telecommunications.formCard.message')}
                        buttonText={t('telecommunications.formCard.buttonText')}
                        labels={t('telecommunications.formCard.labels', {returnObjects: true})}
                        top={3} id='contact'/>
                </section>

                <section className="section--light-gray" id="nav-dark">
                    <FrequentlyAskedQuestions title={t('telecommunications.Faq.title')} questions={questions}/>
                </section>
            </main>
        </>
    );
};

export default Telecommunications;